
export function setDate(state, data) {
  state.date = data
}

export function setType(state, data) {
    state.type_id = data
}



